import { styled } from "@mui/material/styles";
import { SpaceXl, SpaceMd, SpaceLg, SpaceXxl, ColorGray900, SizeBorderWidthThin, ColorGray500 } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const maxWidth = "735px";
const StyledBrandedSearchContainer = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "backgroundColor" && prop !== "imageUrl"
})(({ backgroundColor, imageUrl, theme }) => ({
  backgroundRepeat: "no-repeat",
  border: `${SizeBorderWidthThin} ${ColorGray500} solid`,
  borderRadius: "10px",
  color: ColorGray900,
  minHeight: "130px",
  width: "100%",
  marginTop: "10px",
  backgroundColor: backgroundColor || "transparent",
  backgroundImage: imageUrl ? `url('${imageUrl}')` : "none",
  [theme.breakpoints.up("lg")]: {
    padding: `${SpaceLg} ${SpaceXxl}`
  },
  [theme.breakpoints.between("md", "lg")]: {
    padding: SpaceLg
  },
  [theme.breakpoints.between("sm", "md")]: {
    padding: SpaceMd,
    gap: SpaceXl
  }
}));
export {
  StyledBrandedSearchContainer,
  maxWidth
};
